if (!customElements.get('push-cart-pairs-with')) {
  customElements.define(
    'push-cart-pairs-with',
    // eslint-disable-next-line no-undef
    class PushCartPairsWith extends window.BAO.CustomElement() {
      connectedCallback () {
        super.connectedCallback()
      }

      setupListeners () {
        if (this.els['toggle-button']) {
          this.els['toggle-button'].element.addEventListener(
            'click',
            this.toggleDrawer.bind(this),
          )
        }

        if (this.els.variantSelector) {
          if (this.els.variantSelector.elements.length > 1) {
            this.productJSON = JSON.parse(
              this.els.productJSON.element.textContent,
            )

            this.els.variantSelector.elements.forEach(selector => {
              selector.addEventListener('change', this.variantChange.bind(this))
            })
          }
        }
      }

      toggleDrawer () {
        const isExpanded =
          this.els['toggle-button'].element.getAttribute('aria-expanded') ===
          'true'
        this.els['toggle-button'].element.setAttribute(
          'aria-expanded',
          !isExpanded,
        )
        this.els.drawer.element.setAttribute(
          'aria-hidden',
          isExpanded ? 'true' : 'false',
        )
      }

      variantChange () {
        const selectedVariants = Array.from(
          this.els.variantSelector.elements,
        ).map(select => select.value)

        const matchedVariant = this.productJSON.find(variant => {
          return selectedVariants.every(
            (option, index) => variant.options[index] === option,
          )
        })

        this.updateATC(matchedVariant.available)
      }

      updateATC (available) {
        if (available) {
          this.els.atcButton.element.style.display = 'block'
          this.els.bisButton.element.style.display = 'none'
        } else {
          this.els.atcButton.element.style.display = 'none'
          this.els.bisButton.element.style.display = 'block'
        }
      }
    }
  )
}
